import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService } from '@azure/msal-angular';
import { NeqHttpClient } from '@sharedrest/http-client.config';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { AuthenticationService } from '@usercommon/service/authentication.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'neq-logout-page',
  templateUrl: './logout.page.html'
})
export class NeqLogoutPage implements OnInit {

  constructor(
    private readonly authService: AuthenticationService,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly router: Router,
    protected httpClient: NeqHttpClient) {}

  ngOnInit() {

    this.msalBroadcastService.msalSubject$
    .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGOUT_END)
    )
    .subscribe(() => {
      this.router.navigate(['/login']);
    });

    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None)
    )
    .subscribe(() => {
      this.authService.doLogout();
      this.router.navigate(['/login']);
    });
  }
}
